import { useState, useEffect, useRef } from 'react';

export default function InfoTip({ text }) {
  const [open, setOpen] = useState(false);
  const tipRef = useRef();

  useEffect(() => {
    const handleDocClick = (e) => {
      if (tipRef.current && !tipRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    const handleEscape = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handleDocClick);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleDocClick);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  const toggle = (e) => {
    e.stopPropagation();
    e.preventDefault();
    // hover devices already opened it on mouseenter, so a click keeps it open; touch devices toggle
    if (e.type === 'click' && window.matchMedia('(hover: hover)').matches) setOpen(true);
    else setOpen((o) => !o);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      toggle(e);
    }
  };

  return (
    <span
      ref={tipRef}
      className="relative inline-flex"
      onMouseEnter={() => { if (window.matchMedia('(hover: hover)').matches) setOpen(true); }}
      onMouseLeave={() => { if (window.matchMedia('(hover: hover)').matches) setOpen(false); }}
    >
      <span
        role="button"
        tabIndex={0}
        onClick={toggle}
        onKeyDown={handleKeyDown}
        aria-label="More info"
        className="inline-flex h-5 w-5 items-center justify-center rounded-full border border-[#E2E8F0] text-[11px] font-semibold text-gray hover:border-ink hover:text-ink"
      >
        i
      </span>
      {open && (
        <span
          role="tooltip"
          onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
          className="absolute right-0 top-full z-30 mt-2 block w-64 rounded-xl bg-ink px-3 py-2 text-left text-xs font-normal leading-snug text-white shadow-lg"
        >
          {text}
        </span>
      )}
    </span>
  );
}
